import React from 'react';
import { motion } from 'framer-motion';

const Reviews = () => {
  return (
    <section id="reviews" className="py-24 md:py-32 bg-background">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16 md:mb-24"
        >
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-serif text-primary leading-tight">
            No salt, no sharks, no worries— <br className="hidden md:block" />
            <span className="italic text-accent">with a safe ride!</span>
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-16 md:gap-20 max-w-5xl mx-auto">
          <motion.div 
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="relative"
          >
            <span className="text-6xl md:text-8xl font-serif text-accent/20 absolute -top-8 md:-top-12 -left-4 md:-left-6">"</span>
            <p className="font-serif text-xl md:text-3xl text-text-main leading-snug mb-8 md:mb-10 relative z-10">
              Picked us up super fast AND had the cutest little weiner dog named Slinky riding shotgun. I'd give him a million stars if I could.
            </p>
            <div className="h-px w-10 md:w-12 bg-accent mb-3 md:mb-4"></div>
            <span className="text-[0.65rem] md:text-xs font-sans tracking-[0.3em] uppercase text-text-muted font-bold">Emilie Rains</span>
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="relative"
          >
            <span className="text-6xl md:text-8xl font-serif text-accent/20 absolute -top-8 md:-top-12 -left-4 md:-left-6">"</span>
            <p className="font-serif text-xl md:text-3xl text-text-main leading-snug mb-8 md:mb-10 relative z-10">
              Chris and Slinky were absolutely amazing! They made our bachelorette party unforgettable. The karaoke was the highlight of our night.
            </p>
            <div className="h-px w-10 md:w-12 bg-accent mb-3 md:mb-4"></div>
            <span className="text-[0.65rem] md:text-xs font-sans tracking-[0.3em] uppercase text-text-muted font-bold">Stephanie Hang</span>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Reviews;